export const errorsIgnoreList = [
    {
      url: 'notifications',
      status: 403
    }
];
